module.exports = __webpack_public_path__ + "images/ovzc83aa267059f3fffb172c5184e06f810.png";